import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { FaArrowLeft, FaKey } from 'react-icons/fa';
import api from '../../utils/api.service';
import { ENDPOINTS } from '../../utils/api-config';
import './Login.css';

const VerifyOtp = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email;
  
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [resendLoading, setResendLoading] = useState(false);

  useEffect(() => {
    if (!email) {
      navigate('/forgot-password');
    }
  }, [email, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (otp.length !== 6) {
      setError('Please enter a 6-digit code.');
      return;
    }

    setLoading(true);
    setError('');

    try {
      await api.post(ENDPOINTS.AUTH.VERIFY_OTP, { email, otp });
      navigate('/reset-password', { state: { email, otp } });
    } catch (err) {
      setError(err.response?.data?.message || 'Invalid or expired OTP. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    setResendLoading(true);
    setError('');
    try {
      await api.post(ENDPOINTS.AUTH.FORGOT_PASSWORD, { email });
      alert('OTP has been resent to your email.');
    } catch (err) {
      setError('Failed to resend OTP. Please try again later.');
    } finally {
      setResendLoading(false);
    }
  };

  return (
    <div className="login-container">
      {/* ... Left side same as Login ... */}
      <div className="login-left">
        <div className="login-illustration">
          <div className="illustration-overlay">
            <div className="floating-circle circle-1"></div>
            <div className="floating-circle circle-2"></div>
            <div className="floating-circle circle-3"></div>
          </div>
          <div className="illustration-content">
            <div className="silhouette-group">
              <div className="silhouette parent"></div>
              <div className="silhouette child"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="login-right">
        <div className="login-form-container">
          <div className="login-header">
            <div className="brand-logo">
              <div className="brand-logo-image-container">
                <img src="/logo192.png" alt="TinyCare Logo" className="brand-logo-img" />
              </div>
              <span className="brand-text">TinyCare</span>
            </div>
          </div>

          <div className="auth-card">
            <Link to="/forgot-password" className="back-link">
              <FaArrowLeft /> Change Email
            </Link>

            <h2 className="form-title">Verify Code</h2>
            <p className="form-subtitle">
              We've sent a 6-digit code to <strong>{email}</strong>. Enter it below to continue.
            </p>

            <form onSubmit={handleSubmit} className="login-form">
              <div className="form-group">
                <label htmlFor="otp">Verification Code</label>
                <div className="input-with-icon">
                  <FaKey className="input-icon" />
                  <input
                    type="text"
                    id="otp"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
                    placeholder="123456"
                    className="otp-input"
                    maxLength="6"
                    required
                  />
                </div>
              </div>

              {error && <div className="error-message">{error}</div>}

              <button type="submit" className="btn-signin" disabled={loading}>
                {loading ? 'Verifying...' : 'Verify Code'}
              </button>

              <div className="resend-container">
                <p>Didn't receive the code?</p>
                <button 
                  type="button" 
                  className="btn-resend" 
                  onClick={handleResend}
                  disabled={resendLoading}
                >
                  {resendLoading ? 'Resending...' : 'Resend Code'}
                </button>
              </div>
            </form>
          </div>

          <div className="login-footer">
            <p>© TinyCare. All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyOtp;
